export default __webpack_public_path__ + "images/groupem-edit-profile-background.svg";